import { render, staticRenderFns } from "./Acelerometro.vue?vue&type=template&id=f2ca3650"
import script from "./Acelerometro.vue?vue&type=script&lang=js"
export * from "./Acelerometro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports